'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setLogoAlignment = exports.watchSaveTemplateApplicationSettings = exports.watchGetTemplatesSettings = exports.saveTemplateApplicationSettingsSaga = exports.fetchTemplatesSettingsSaga = exports.cancelTemplateApplicationSettings = exports.saveTemplateApplicationSettings = exports.changeTemplateApplicationSettingsProperty = exports.getTemplatesSettings = exports.CANCEL_TEMPLATE_SETTINGS = exports.SAVE_TEMPLATESETTINGS_TYPES = exports.GET_TEMPLATES_SETTINGS_TYPES = exports.watchDeleteTemplateConfigurationSaga = exports.watchCancelTemplateConfiguration = exports.watchCloneTemplate = exports.watchSetCurrentTemplate = exports.watchSaveTemplate = exports.watchGetTemplate = exports.watchGetTemplates = exports.setTab = exports.setCurrentTemplateSaga = exports.saveTemplateSaga = exports.fetchTemplateSaga = exports.fetchTemplatesSaga = exports.templateSelector = exports.changeComponentProperty = exports.changeTemplatesProperty = exports.changeTemplatesRowProperty = exports.resetTemplateConfiguration = exports.cancelTemplateConfiguration = exports.changeProperty = exports.selectComponent = exports.loadTemplate = exports.cloneTemplate = exports.deleteTemplateConfiguration = exports.deleteTemplate = exports.saveTemplate = exports.getTemplate = exports.getTemplates = exports.setCurrentTemplate = exports.CHANGE_COMPONENT_PROPERTY = exports.CHANGE_PROPERTY = exports.SELECT_COMPONENT = exports.SAVE_TEMPLATE_TYPES = exports.GET_TEMPLATE_TYPES = exports.GET_TEMPLATES_TYPES = exports.SET_CURRENT_TEMPLATE = undefined;

var _templates = require('./templates');

Object.defineProperty(exports, 'SET_CURRENT_TEMPLATE', {
    enumerable: true,
    get: function get() {
        return _templates.SET_CURRENT_TEMPLATE;
    }
});
Object.defineProperty(exports, 'GET_TEMPLATES_TYPES', {
    enumerable: true,
    get: function get() {
        return _templates.GET_TEMPLATES_TYPES;
    }
});
Object.defineProperty(exports, 'GET_TEMPLATE_TYPES', {
    enumerable: true,
    get: function get() {
        return _templates.GET_TEMPLATE_TYPES;
    }
});
Object.defineProperty(exports, 'SAVE_TEMPLATE_TYPES', {
    enumerable: true,
    get: function get() {
        return _templates.SAVE_TEMPLATE_TYPES;
    }
});
Object.defineProperty(exports, 'SELECT_COMPONENT', {
    enumerable: true,
    get: function get() {
        return _templates.SELECT_COMPONENT;
    }
});
Object.defineProperty(exports, 'CHANGE_PROPERTY', {
    enumerable: true,
    get: function get() {
        return _templates.CHANGE_PROPERTY;
    }
});
Object.defineProperty(exports, 'CHANGE_COMPONENT_PROPERTY', {
    enumerable: true,
    get: function get() {
        return _templates.CHANGE_COMPONENT_PROPERTY;
    }
});
Object.defineProperty(exports, 'setCurrentTemplate', {
    enumerable: true,
    get: function get() {
        return _templates.setCurrentTemplate;
    }
});
Object.defineProperty(exports, 'getTemplates', {
    enumerable: true,
    get: function get() {
        return _templates.getTemplates;
    }
});
Object.defineProperty(exports, 'getTemplate', {
    enumerable: true,
    get: function get() {
        return _templates.getTemplate;
    }
});
Object.defineProperty(exports, 'saveTemplate', {
    enumerable: true,
    get: function get() {
        return _templates.saveTemplate;
    }
});
Object.defineProperty(exports, 'deleteTemplate', {
    enumerable: true,
    get: function get() {
        return _templates.deleteTemplate;
    }
});
Object.defineProperty(exports, 'deleteTemplateConfiguration', {
    enumerable: true,
    get: function get() {
        return _templates.deleteTemplateConfiguration;
    }
});
Object.defineProperty(exports, 'cloneTemplate', {
    enumerable: true,
    get: function get() {
        return _templates.cloneTemplate;
    }
});
Object.defineProperty(exports, 'loadTemplate', {
    enumerable: true,
    get: function get() {
        return _templates.loadTemplate;
    }
});
Object.defineProperty(exports, 'selectComponent', {
    enumerable: true,
    get: function get() {
        return _templates.selectComponent;
    }
});
Object.defineProperty(exports, 'changeProperty', {
    enumerable: true,
    get: function get() {
        return _templates.changeProperty;
    }
});
Object.defineProperty(exports, 'cancelTemplateConfiguration', {
    enumerable: true,
    get: function get() {
        return _templates.cancelTemplateConfiguration;
    }
});
Object.defineProperty(exports, 'resetTemplateConfiguration', {
    enumerable: true,
    get: function get() {
        return _templates.resetTemplateConfiguration;
    }
});
Object.defineProperty(exports, 'changeTemplatesRowProperty', {
    enumerable: true,
    get: function get() {
        return _templates.changeTemplatesRowProperty;
    }
});
Object.defineProperty(exports, 'changeTemplatesProperty', {
    enumerable: true,
    get: function get() {
        return _templates.changeTemplatesProperty;
    }
});
Object.defineProperty(exports, 'changeComponentProperty', {
    enumerable: true,
    get: function get() {
        return _templates.changeComponentProperty;
    }
});
Object.defineProperty(exports, 'templateSelector', {
    enumerable: true,
    get: function get() {
        return _templates.templateSelector;
    }
});
Object.defineProperty(exports, 'fetchTemplatesSaga', {
    enumerable: true,
    get: function get() {
        return _templates.fetchTemplatesSaga;
    }
});
Object.defineProperty(exports, 'fetchTemplateSaga', {
    enumerable: true,
    get: function get() {
        return _templates.fetchTemplateSaga;
    }
});
Object.defineProperty(exports, 'saveTemplateSaga', {
    enumerable: true,
    get: function get() {
        return _templates.saveTemplateSaga;
    }
});
Object.defineProperty(exports, 'setCurrentTemplateSaga', {
    enumerable: true,
    get: function get() {
        return _templates.setCurrentTemplateSaga;
    }
});
Object.defineProperty(exports, 'setTab', {
    enumerable: true,
    get: function get() {
        return _templates.setTab;
    }
});
Object.defineProperty(exports, 'watchGetTemplates', {
    enumerable: true,
    get: function get() {
        return _templates.watchGetTemplates;
    }
});
Object.defineProperty(exports, 'watchGetTemplate', {
    enumerable: true,
    get: function get() {
        return _templates.watchGetTemplate;
    }
});
Object.defineProperty(exports, 'watchSaveTemplate', {
    enumerable: true,
    get: function get() {
        return _templates.watchSaveTemplate;
    }
});
Object.defineProperty(exports, 'watchSetCurrentTemplate', {
    enumerable: true,
    get: function get() {
        return _templates.watchSetCurrentTemplate;
    }
});
Object.defineProperty(exports, 'watchCloneTemplate', {
    enumerable: true,
    get: function get() {
        return _templates.watchCloneTemplate;
    }
});
Object.defineProperty(exports, 'watchCancelTemplateConfiguration', {
    enumerable: true,
    get: function get() {
        return _templates.watchCancelTemplateConfiguration;
    }
});
Object.defineProperty(exports, 'watchDeleteTemplateConfigurationSaga', {
    enumerable: true,
    get: function get() {
        return _templates.watchDeleteTemplateConfigurationSaga;
    }
});

var _templatesSettings = require('./templatesSettings');

Object.defineProperty(exports, 'GET_TEMPLATES_SETTINGS_TYPES', {
    enumerable: true,
    get: function get() {
        return _templatesSettings.GET_TEMPLATES_SETTINGS_TYPES;
    }
});
Object.defineProperty(exports, 'SAVE_TEMPLATESETTINGS_TYPES', {
    enumerable: true,
    get: function get() {
        return _templatesSettings.SAVE_TEMPLATESETTINGS_TYPES;
    }
});
Object.defineProperty(exports, 'CANCEL_TEMPLATE_SETTINGS', {
    enumerable: true,
    get: function get() {
        return _templatesSettings.CANCEL_TEMPLATE_SETTINGS;
    }
});
Object.defineProperty(exports, 'getTemplatesSettings', {
    enumerable: true,
    get: function get() {
        return _templatesSettings.getTemplatesSettings;
    }
});
Object.defineProperty(exports, 'changeTemplateApplicationSettingsProperty', {
    enumerable: true,
    get: function get() {
        return _templatesSettings.changeTemplateApplicationSettingsProperty;
    }
});
Object.defineProperty(exports, 'saveTemplateApplicationSettings', {
    enumerable: true,
    get: function get() {
        return _templatesSettings.saveTemplateApplicationSettings;
    }
});
Object.defineProperty(exports, 'cancelTemplateApplicationSettings', {
    enumerable: true,
    get: function get() {
        return _templatesSettings.cancelTemplateApplicationSettings;
    }
});
Object.defineProperty(exports, 'fetchTemplatesSettingsSaga', {
    enumerable: true,
    get: function get() {
        return _templatesSettings.fetchTemplatesSettingsSaga;
    }
});
Object.defineProperty(exports, 'saveTemplateApplicationSettingsSaga', {
    enumerable: true,
    get: function get() {
        return _templatesSettings.saveTemplateApplicationSettingsSaga;
    }
});
Object.defineProperty(exports, 'watchGetTemplatesSettings', {
    enumerable: true,
    get: function get() {
        return _templatesSettings.watchGetTemplatesSettings;
    }
});
Object.defineProperty(exports, 'watchSaveTemplateApplicationSettings', {
    enumerable: true,
    get: function get() {
        return _templatesSettings.watchSaveTemplateApplicationSettings;
    }
});
Object.defineProperty(exports, 'setLogoAlignment', {
    enumerable: true,
    get: function get() {
        return _templatesSettings.setLogoAlignment;
    }
});

var _redux = require('redux');

var _templates2 = _interopRequireDefault(_templates);

var _templatesSettings2 = _interopRequireDefault(_templatesSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var templateApplication = (0, _redux.combineReducers)({
    templates: _templates2.default,
    templatesSettings: _templatesSettings2.default
});

exports.default = templateApplication;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/templates/index.js
// module id = 70
// module chunks = 0